import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { IbpConfirmationDialogService } from "../../../../ibp-services/third-party/ibp-prime-ng/ibp-confirmation-dialog.service";
import { ConfirmationService } from "primeng/api";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({selector: 'ibp-confirm-dialog',
  template: '<p-confirmDialog class="ibp-confirm-dialog"></p-confirmDialog>',
  styleUrls: ['./ibp-confirm-dialog.component.scss'],
  standalone: true,
  imports: [ConfirmDialog],
})
export class IbpConfirmDialogComponent implements OnInit, OnDestroy {
  private confirmationRunner = inject(ConfirmationService);
  private confirmationService = inject(IbpConfirmationDialogService);

  private unsubscribe$ = new Subject<void>();

  public ngOnInit(): void {
    this.confirmationService.confirmationTrigger$.pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(config => this.confirmationRunner.confirm(config))
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
